import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import TableauContainers from "../../TableauContainer/TableauContainer";
class TableauReport extends Component {
    render() {
        return (
            <div className="mainContainer">
                <div style={{ marginTop: 20 }}>
                    <TableauContainers url="https://tableau.mak.mn/views/Tender_dashboard/Tender?:origin=card_share_link&:embed=y" />
                </div>
            </div>
        );
    }
}

export default withRouter(TableauReport);
